"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _Link = _interopRequireDefault(require("../Link"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const DropdownMenuOption = ({
  counter,
  onClick,
  children
}) => {
  return (0, _jsxRuntime.jsxs)(_Link.default, {
    role: "menuitem",
    trackingName: "Topbar",
    trackingEvent: 'DropdownMenu click: ' + (children ? children : ''),
    css: theme => [(0, _styles.dropdownMenuOption)(theme)],
    onClick: onClick,
    removeUnderline: true,
    small: true,
    "aria-label": children ? `Option: ${children}${counter ? `, ${counter} notifications` : ''}` : '',
    children: [children ? children : '', counter ? ` (${counter})` : '']
  });
};
var _default = exports.default = DropdownMenuOption;